import styled from "styled-components";
import theme from "../../../../Themes/light";

export const ContainerCobrancaContainer = styled.div`
  display: flex;
  width: 125rem;
  max-width: 90vw;
  justify-content: center;
  align-items: center;
  gap: 6rem;
  padding: 0rem 1rem;

  > .containerImagem {
    min-width: 40%;

    > .imagem {
      width: 100%;
    }
  }

  > .containerTexto {
    text-align: left;

    > span {
      color: ${theme.colors.secondary};
      font-weight: bold;
    }
  }

  @media (max-width: 1024px) {
    padding: 0rem 6rem;
    flex-direction: column;

    .containerImagem {
      width: 100%;

      .imagem {
        max-width: 50rem;
      }
    }

    .containerTexto {
      text-align: center;
    }
  }
`;
